export const ID_TOKEN = '#'
export const ID_PATTERN = /[0-9]/
export const ID_MASK = `${ID_TOKEN.repeat(11)}`
export const ID_LENGTH = 11
